import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Missing Supabase environment variables");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Role constants matching enum
export const USER_ROLES = {
  GENERAL: "GENERAL",
  BRAND: "BRAND",
  CAUSE: "CAUSE",
  INFLUENCER: "INFLUENCER",
  ADMIN: "ADMIN",
};

export const ROLE_DESCRIPTIONS = {
  [USER_ROLES.GENERAL]: "General user with basic platform access",
  [USER_ROLES.BRAND]:
    "Brand partner who can create campaigns and collaborate with influencers",
  [USER_ROLES.CAUSE]:
    "Non-profit organization or cause that can receive donations and support",
  [USER_ROLES.INFLUENCER]:
    "Content creator who can promote campaigns and causes",
  [USER_ROLES.ADMIN]:
    "Administrator with full platform access and management capabilities",
};

export const ROLE_DETAILS = {
  [USER_ROLES.GENERAL]: {
    description: "Default account. Browse, purchase, and gift Impact Art.",
    requirements: "None",
  },
  [USER_ROLES.CAUSE]: {
    description: "For registered NGOs and charities. Create campaigns and receive donations.",
    requirements: "Requires verification.",
  },
  [USER_ROLES.BRAND]: {
    description: "For businesses supporting social impact. Create branded campaigns with analytics.",
    requirements: "Requires verification.",
  }
};
